import React, { useEffect, useRef, useState } from "react";
import ReactPlayer from "react-player";

const normalizeVideoUrl = (url) => {
  if (!url) return url;

  try {
    const urlObj = new URL(url);

    if (
      urlObj.hostname.includes("youtube.com") &&
      urlObj.searchParams.get("v")
    ) {
      const videoId = urlObj.searchParams.get("v");
      return `https://www.youtube.com/watch?v=${videoId}`;
    }

    if (urlObj.hostname === "youtu.be") {
      const videoId = urlObj.pathname.slice(1);
      return `https://www.youtube.com/watch?v=${videoId}`;
    }

    if (
      urlObj.hostname.includes("youtube.com") &&
      urlObj.pathname.includes("/embed/")
    ) {
      const videoId = urlObj.pathname.split("/embed/")[1]?.split("/")[0];
      return videoId ? `https://www.youtube.com/watch?v=${videoId}` : url;
    }
  } catch (err) {
    console.error("Invalid video URL:", url);
  }

  return url;
};

const BlogVideoPlayer = ({ url }) => {
  const containerRef = useRef(null);
  const isInViewRef = useRef(false);
  const [isInView, setIsInView] = useState(false);
  // Start true so in-view videos autoplay like before; viewport gate prevents off-screen playback.
  const [wantsPlay, setWantsPlay] = useState(true);

  const videoUrl = normalizeVideoUrl(url);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        const visible = entry.isIntersecting;
        isInViewRef.current = visible;
        setIsInView(visible);
      },
      { threshold: 0.35 },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const handlePlay = () => {
    setWantsPlay(true);
  };

  const handlePause = () => {
    // Ignore pause events triggered when the player leaves the viewport.
    if (isInViewRef.current) {
      setWantsPlay(false);
    }
  };

  return (
    <div
      ref={containerRef}
      className="my-6"
      style={{
        position: "relative",
        width: "100%",
        paddingTop: "56.25%",
      }}
    >
      <ReactPlayer
        src={videoUrl}
        controls
        playing={isInView && wantsPlay}
        width="100%"
        height="100%"
        onPlay={handlePlay}
        onPause={handlePause}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
        }}
        config={{
          youtube: {
            playerVars: {
              origin:
                typeof window !== "undefined" ? window.location.origin : "",
              enablejsapi: 1,
              modestbranding: 1,
            },
          },
        }}
      />
    </div>
  );
};

export default BlogVideoPlayer;
